import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "policies pt-0" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "policies__head" }
const _hoisted_5 = { class: "policies__head__title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Pólizas", -1)
const _hoisted_7 = {
  key: 0,
  class: "dropdown-container"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "policies__body" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "policies__input-dates" }
const _hoisted_14 = { class: "policies__input-dates__input" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", null, "Ingresa tu búsqueda", -1)
const _hoisted_16 = { class: "input-group mb-3" }
const _hoisted_17 = { class: "policies__input-dates__start-date" }
const _hoisted_18 = { class: "input-group mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("small", null, "Buscar desde:", -1)
const _hoisted_20 = { class: "policies__input-dates__end-date" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", null, "Buscar hasta:", -1)
const _hoisted_22 = { class: "input-group mb-3" }
const _hoisted_23 = { class: "policies__input-dates__end-date" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("small", null, "Estado de pólizas:", -1)
const _hoisted_25 = { class: "input-group mb-3" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<option value=\"-1\">Todas</option><option value=\"1\">Activas</option><option value=\"0\">Anuladas</option><option value=\"2\">Congeladas</option><option value=\"3\">Deuda pendiente</option>", 5)
const _hoisted_31 = [
  _hoisted_26
]
const _hoisted_32 = { class: "policies__input-dates__end-date" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("small", null, "Estado débito:", -1)
const _hoisted_34 = { class: "input-group mb-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "-1" }, "Todas", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Con Débito Automático", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Sin Débito Automático", -1)
const _hoisted_38 = [
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "policies__input-dates__btn-policies" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("small", { class: "invisible d-block" }, ".", -1)
const _hoisted_41 = {
  key: 0,
  class: "text-center text-main"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin d-block mb-1" }, null, -1)
const _hoisted_43 = { class: "policies__body__table" }
const _hoisted_44 = {
  key: 0,
  class: "table table-hover table-striped"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Póliza"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "DNI"),
    /*#__PURE__*/_createElementVNode("th", null, "Prima"),
    /*#__PURE__*/_createElementVNode("th", null, "Acumulado"),
    /*#__PURE__*/_createElementVNode("th", null, "Primas pendientes"),
    /*#__PURE__*/_createElementVNode("th", null, "DA"),
    /*#__PURE__*/_createElementVNode("th", null, "Fecha de compra"),
    /*#__PURE__*/_createElementVNode("th", null, "Nro. Años"),
    /*#__PURE__*/_createElementVNode("th", null, "Devolución"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1)
const _hoisted_46 = { class: "text-center" }
const _hoisted_47 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_48 = {
  key: 0,
  class: "badge badge-info"
}
const _hoisted_49 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_50 = {
  key: 1,
  class: "pagination"
}
const _hoisted_51 = { class: "modal-error__head" }
const _hoisted_52 = ["src"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h3", null, "Ups!", -1)
const _hoisted_54 = { class: "modal-error__head" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "modal-blue__head pt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-timex fa-3x text-danger" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Anular Póliza")
], -1)
const _hoisted_56 = {
  key: 0,
  class: "modal-blue__head"
}
const _hoisted_57 = { class: "d-flex justify-content-between" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.userRole !== 'ReadOnly')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_b_dropdown, {
                      id: "dropdown-1",
                      class: "m-md-2"
                    }, {
                      "button-content": _withCtx(() => [
                        (!_ctx.downloading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Descargar Reportes"))
                          : _createCommentVNode("", true),
                        (_ctx.downloading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Descargando reporte..."))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("li", null, [
                          _createVNode(_component_b_dropdown_item, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadReport()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("   Pólizas")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_b_dropdown_item, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPaymentsReport()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("   Pagos")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_b_dropdown_item, {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadReservationsReport()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("   Reservas")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_b_dropdown_item, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadCustomReport()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("   Personalizado")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: "Ingrese búsqueda",
                        "aria-label": "Username",
                        "aria-describedby": "basic-addon1",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.q) = $event)),
                        onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.loadPolicies()), ["native","enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.query.q]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_datepicker, {
                        "model-value": _ctx.query.startDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.query.startDate) = $event)),
                        clearable: false,
                        placeholder: 'Desde'
                      }, null, 8, ["model-value"]),
                      _createElementVNode("button", {
                        class: "clear-date",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearDate(true)))
                      }, " ✕ ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_datepicker, {
                        "model-value": _ctx.query.endDate,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.query.endDate) = $event)),
                        clearable: false,
                        placeholder: 'Hasta'
                      }, null, 8, ["model-value"]),
                      _createElementVNode("button", {
                        class: "clear-date",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearDate(false)))
                      }, " ✕ ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("select", {
                        name: "",
                        id: "",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.query.status) = $event))
                      }, _hoisted_31, 512), [
                        [_vModelSelect, _ctx.query.status]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("select", {
                        name: "",
                        id: "",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.query.debitStatus) = $event))
                      }, _hoisted_38, 512), [
                        [_vModelSelect, _ctx.query.debitStatus]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadPolicies()))
                    }, " Buscar ")
                  ])
                ]),
                (_ctx.flags.searching)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createTextVNode(" Cargando pólizas... ")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_43, [
                  (!_ctx.flags.searching)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.policies, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.policyId
                            }, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_router_link, {
                                  to: {
                            name: 'admineditpolicy',
                            query: { policyNumber: item.policyNumber },
                          }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.policyNumber), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", null, _toDisplayString(item.user.firstName) + " " + _toDisplayString(item.user.lastName), 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("small", null, "(" + _toDisplayString(item.user.email) + ")", 1)
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(item.user.identificationNumber), 1),
                              _createElementVNode("td", null, "S/" + _toDisplayString(item.paymentAmount), 1),
                              _createElementVNode("td", null, "S/" + _toDisplayString(item.totalAmountSaved), 1),
                              _createElementVNode("td", null, _toDisplayString(item.pendingPayments), 1),
                              _createElementVNode("td", null, _toDisplayString(item.debitAutomatic ? "Si" : "No"), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.createdOn)), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(item.periodicity), 1),
                              _createElementVNode("td", null, " S/" + _toDisplayString(_ctx.formatNumber(item.totalAmountSavedFinal)), 1),
                              _createElementVNode("td", null, [
                                (item.entityStatus === 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Anulada"))
                                  : _createCommentVNode("", true),
                                (item.entityStatus === 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (item.freezed)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Congelada"))
                                        : _createCommentVNode("", true),
                                      (!item.freezed)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Activa"))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.policies && _ctx.policies.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createVNode(_component_pagination, {
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.page) = $event)),
                        records: _ctx.rowCount,
                        "per-page": 20,
                        onPaginate: _ctx.changePage
                      }, null, 8, ["modelValue", "records", "onPaginate"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "md",
      "modal-class": "modal-blue",
      ref: "modal-error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("img", {
            src: require('@/assets/images/app/alert.svg'),
            alt: ""
          }, null, 8, _hoisted_52),
          _hoisted_53
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("p", null, _toDisplayString(_ctx.errors.message), 1)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-confirm",
      "ok-only": "",
      "ok-title": "Esta seguro de anular la poliza?",
      centered: "",
      size: "sm",
      "modal-class": "modal-blue",
      ref: "modal-confirm"
    }, {
      default: _withCtx(() => [
        _hoisted_55,
        (_ctx.selectedPolicy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("p", null, " ¿Esta seguro de anular la póliza " + _toDisplayString(_ctx.selectedPolicy.referencePolicyNumber) + "? ", 1),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  class: "btn btn-default",
                  style: {"color":"#fff"},
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeModal('modal-confirm')))
                }, " Cerrar "),
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.cancel())),
                  disabled: _ctx.deleting
                }, [
                  (!_ctx.deleting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Anular"))
                    : _createCommentVNode("", true),
                  (_ctx.deleting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Anulando póliza..."))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_58)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512)
  ]))
}